var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.view == 'estados-de-pedido')?_c('view-component',{attrs:{"model_name":"order_status"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }